var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_vm._v(" "),_c('span',{class:[_vm.visible ? 'icon--visible' : 'icon--invisible' ],on:{"click":_vm.toggleVisibility}},[_c(_vm.currentIcon,{tag:"component"})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }